export default __webpack_public_path__ + "static/media/beauty-box-1.94faa172.png";